import React from "react";
import "../../../css/components/buttons/SecondaryButton.css";

const SecondaryButton = ({ children, text, ...props }) => (
  <button className="secondary-btn" {...props}>
    <div className="nav-regular">{text || children}</div>
  </button>
);

export default SecondaryButton;
